<template>
    <div>
        <div>
            <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">订单信息
                <el-button type="primary" size="small" style="width: 80px;position: absolute;right: 120px;" @click="onExport" >导出</el-button>
                <el-button  size="small"  style="width: 80px;position: absolute;right: 20px;" @click.native="goback">返回</el-button>
            </h1>
            <div class="list">
                <div class="list-item">
                    <span class="item-title">订单ID:</span>
                    <span>{{ orderData.id }}</span>
                </div>
                <div class="list-item">
                    <span class="item-title">订单编号:</span>
                    <span>{{ orderData.ordNo }}</span>
                </div>
                <div class="list-item">
                    <span class="item-title">订单状态:</span>
                    <span v-if="orderData.status==1">待发货</span>
                    <span v-if="orderData.status==2">已发货</span>
                    <span v-if="orderData.status==3">已完成</span>
                    <span v-if="orderData.status==4">取消订单</span>
                </div>
                <div class="list-item">
                    <span class="item-title">下单时间:</span>
                    {{ orderData.createTime | formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                </div>
                <div class="list-item">
                    <span class="item-title">下单时间:</span>
                    {{ orderData.integralNum }}
                </div>
                <div class="list-item">
                    <span class="item-title">运单编号:</span>
                    {{ orderData.expressNo }}
                    <span class="btu" @click="editExpressNo()">修改</span>
                </div>
                <div class="list-item">
                    <span class="item-title">快递方式:</span>
                    <span v-if="orderData.expressType==0">DHL快递</span>
                    <span v-if="orderData.expressType==1">Fedex快递</span>
                    <span v-if="orderData.expressType==2">霍夫曼快递</span>
                    <span v-if="orderData.expressType==3">自提</span>
                   [单号]{{ orderData.expressNo }}
                    <span class="btu" @click="editExpressType()">修改</span>
                </div>
                <div class="list-item">
                    <span class="item-title">运费:</span>
                    ￥{{ orderData.expressFee?orderData.expressFee:'0.00'}}

                    <span class="btu" @click="editFreight()">修改</span>
                </div>

                <div class="list-item">
                    <span class="item-title">备注信息:</span>
                    <span>{{
                        orderData.remark?orderData.remark:'无'
                    }}</span>

                </div>
            </div>



            <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">礼品信息</h1>
            <div class="list">

                <div class="list-item">
                    <span class="item-title">礼品编码:</span>
                    <span>   {{ giftData.giftCode }}</span>
                </div>
                <div class="list-item">
                    <span class="item-title">数量:</span>
                    <span> {{  orderData.num }}</span>
                </div>
                <div class="list-item">


                    <span class="item-title">礼品名称:</span>
                    <span>  {{  giftData.name }}</span>
                </div>



                <div class="list-item">
                    <span class="item-title">积分:</span>
                    <span>   {{  giftData.integralNum }}</span>
                </div>
                <div class="list-item">
                    <span class="item-title">图片:</span>
                    <span>  <el-popover placement="right" trigger="hover">
                        <img :src="giftData.imgUrl" style="width:400px;border-radius:3px;">
                        <img slot="reference" :src="giftData.imgUrl"
                             style="max-height: 50px;max-width: 50px;border-radius:5px;">
                    </el-popover></span>
                </div>

            </div>





            <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">买家信息</h1>
            <div class="list">



                <div class="list-item">
                    <span class="item-title">用户昵称:</span>
                    <span>      {{ orderData.usernick }}</span>
                </div>

                <div class="list-item">
                    <span class="item-title">用户邮箱:</span>
                    <span>      {{ orderData.useremail }}</span>
                </div>

                <div class="list-item">
                    <span class="item-title">取货方式:</span>
                    <span v-if="orderData.expressType==0">快递</span>
                    <span v-if="orderData.expressType==1">快递</span>
                    <span v-if="orderData.expressType==2">快递</span>
                    <span v-if="orderData.expressType==3">自提</span>
                </div>





                <div class="list-item">

                    <span class="item-title">收货人:</span>
                    <span>   {{ orderData.useraddressname }}</span>
                </div>

                <div class="list-item">

                    <span class="item-title">联系方式:</span>
                    <span>   {{ orderData.useraddressphone }}</span>
                </div>
                <div class="list-item">

                    <span class="item-title">收货地址:</span>
                    <span>   {{ orderData.useraddress }}</span>
                </div>




            </div>


        </div>


        <!-- 修改运费 -->
        <el-dialog title="修改运费" :visible.sync="freightVisible" :before-close="cancelFreight" width="15%" v-dialogDrag>
            <el-form >
                <el-form-item class="query-form-item  query-form-item-big">
                    <el-input type="test" v-model="orderData.expressFee" placeholder="在此输入修改后的价格">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelFreight">取消</el-button>
                <el-button type="primary" @click.native="updateExpressFeeFn(orderData.expressFee)">确定</el-button>
            </div>
        </el-dialog>
        <!-- 修改快递方式 -->
        <el-dialog title="修改快递方式" :visible.sync="expressTypeVisible" :before-close="cancelExpressType" width="15%"
            v-dialogDrag>
            <el-form>
                <el-form-item class="query-form-item  query-form-item-big" >
                    <el-select placeholder="请选择" v-model="orderData.expressType">
                        <el-option v-for="item in expressTypeList" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelExpressType">取消</el-button>
                <el-button type="primary" @click.native="updateExpressTypeFn(orderData.expressType)">确定</el-button>
            </div>
        </el-dialog>
          <!-- 修改运单编号 -->
          <el-dialog title="修改运单编号" :visible.sync="expressNoVisible" :before-close="cancelExpressNo" width="15%"
          v-dialogDrag>
          <el-form>
              <el-form-item class="query-form-item  query-form-item-big" >
                <el-input type="test" v-model="orderData.expressNo" placeholder="在此输入运单编号">
                </el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click.native="cancelExpressNo">取消</el-button>
              <el-button type="primary" @click.native="updateExpressNoFn(orderData.expressNo)">确定</el-button>
          </div>
      </el-dialog>
    </div>
</template>

<script>
    import {
        getDetailsApi,
        updateApi,
        exportOrderDetailApi
    } from "@/api/integral/orderList";
    import {
        BASE_URL
    } from "../../config/app";
    export default {
        data() {
            return {
                loading: false,
                orderData: {},
                giftData: {},
                list: [{
                        id: "00000000",
                        picture: "",
                        name: "Welded Plate Heat Exchanger",
                        weight: "100kg",
                        specs: "304/0.5/H"
                    },
                    {
                        id: "00000000",
                        picture: "",
                        name: "Welded Plate Heat Exchanger",
                        weight: "100kg",
                        specs: "304/0.5/H"
                    }
                ],
                freightVisible: false,
                expressTypeVisible: false,
                expressNoVisible:false,
                expressTypeList: [{
                        id: '0',
                        name: 'DHL快递'
                    },
                    {
                        id: '1',
                        name: 'Fedex快递'
                    },
                    {
                        id: '2',
                        name: '霍夫曼快递'
                    },
                    {
                        id: '3',
                        name: '自提'
                    }
                ]

            };
        },
        methods: {
          goback() {
                this.$router.go(-1)
            },
            getDetailsFn() {
                let theId = {
                    id: this.orderData.id
                }
                getDetailsApi(theId)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.orderData = response.data;
                        this.giftData = response.data.hfIntegralGift;
                    })
                    .catch(() => {});
            },
            //修改运费
            updateExpressFeeFn(name) {
                let theId = {
                    id: this.orderData.id,
                    expressFee: name
                }
                updateApi(theId)
                    .then(response => {
                        console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$修改', response)
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.freightVisible = false;
                        this.$message.success("修改成功");
                        this.getDetailsFn();
                    })
                    .catch(() => {});
            },
            editFreight() {
                this.freightVisible = true;
            },
            cancelFreight() {
                this.freightVisible = !this.freightVisible;
                this.getDetailsFn();
            },
            //修改快递方式
            updateExpressTypeFn(name) {
                let theId = {
                    id: this.orderData.id,
                    expressType: name
                }
                updateApi(theId)
                    .then(response => {
                        console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$修改', response)
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.expressTypeVisible = false;
                        this.$message.success("修改成功");
                        this.getDetailsFn();
                    })
                    .catch(() => {});
            },
            editExpressType() {
                this.expressTypeVisible = true;
            },
            cancelExpressType() {
                this.expressTypeVisible = !this.expressTypeVisible;
                this.getDetailsFn();
            },
            //修改运单编号
            updateExpressNoFn(name) {
                let theId = {
                    id: this.orderData.id,
                    expressNo: name
                }
                updateApi(theId)
                    .then(response => {
                        console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$修改', response)
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.expressNoVisible = false;
                        this.$message.success("修改成功");
                        this.getDetailsFn();
                    })
                    .catch(() => {});
            },
            editExpressNo() {
                this.expressNoVisible = true;
            },
            cancelExpressNo() {
                this.expressNoVisible = !this.expressNoVisible;
                this.getDetailsFn();
            },
            //导出
            onExport(){
              window.location.href = BASE_URL + "/hfIntegralGiftLogManage/exportOrderDetail?id=" + this.orderData.id+"&endTime="
            }

        },
        filters: {},
        mounted() {},
        created() {
            this.orderData.id = this.$route.query.id;
            this.getDetailsFn()
        }
    };

</script>
<style lang="scss" scoped>
.list{
    display: flex;
    color: #000;
    font-size: 13px;
    margin: 15px 0;
    flex-wrap: wrap;
}
.list-item{
    margin-right: 40px;
    margin-bottom: 15px;
    .item-title{
        margin-right: 10px;
    }
    .btu{
        margin-left: 15px;
        color: #2d8cf0;
    }
}
.query-form-item{
    color: #000;
    text-align: left;
}
    ::v-deep .query-form {
        color: #606266;
        width: 1200px !important;
        border: 1px solid #f4f4f5;
        border-bottom: none;
        margin-bottom: 40px;
        /* border-left: none; */
    }

    ::v-deep .query-form-item {
        /* display: block !important; */
        width: 50% !important;
        margin-right: 0 !important;
        padding: 10px 0;
        margin-bottom: 0 !important;
        border-bottom: 1px solid #f4f4f5;
        /* border-left: 1px solid #F4F4F5; */
    }

    ::v-deep .query-form-item-big {
        width: 100% !important;
    }

    ::v-deep .el-form-item__label {
        padding-left: 20px;
    }

    /* ::v-deep .query-form-item-big .el-form-item__content { */
        /* padding: 0 20px;
    text-indent: 4em; */
    /* } */

    .inquiryDetailsTitle {
        line-height: 50px;
        background: #f4f4f5;
        padding-left: 20px;
        color: #000;
    }

    ::v-deep .el-table--border {
        width: 1200px;
    }

    ::v-deep .el-table__body td {
        padding: 12px 0 !important;
    }

    ::v-deep .detailsBox {
        /* padding: 0 20px 20px 0; */
        width: 1088px;
    }

</style>
